export const baseUrl = 'https://api.agency.bizpay.pro'
// export const baseUrl = 'http://3.38.20.173:8080'
// export const baseUrl = 'http://192.168.0.11:8080'

// export const baseUrl = 'http://192.168.0.9:8080'
